import React from "react";
import "../../App.css";

import { BackToIndustryVerticalsButton } from "../layout/BackButton";
import QuickLinksSection from "../products/QuickLinksSection";

// Environment Detail Page
function EnvironmentPage({ handleNavClick }) {
  return (
    <div className="industry-detail-page env-page">
      <BackToIndustryVerticalsButton handleNavClick={handleNavClick} />

      {/* Environment Header */}
      <div className="env-header">
        <div className="section__container">
          <h2 className="section__title">Environment</h2>
          <p className="section__intro">
            Environmental monitoring and conservation through advanced geospatial analysis.
          </p>
        </div>
      </div>

      {/* About Section */}
      <section className="env-about-section">
        <div className="section__container env-about-container">
          <div className="env-about-text">
            <h2>Environmental Solutions</h2>
            <p>
              We offer engineering and environmentally conscious solutions focused on Environmental Impact Assessment,
              Pollution Control Board Approvals, CRZ, Environmental Audit, Environmental Management Plan, Landscape Design,
              Biodiversity Study, Carbon Footprint Studies, and Sustainability.
            </p>
          </div>
          <div className="env-about-image  env-about-image--full">
            <img src="/env.jpg" alt="Environmental Consultancy Infographic" />
          </div>
          </div>
      </section>

      {/* Feature Section 1: Environmental Impact Assessment */}
      <section className="env-feature-section">
        <div className="section__container env-feature-container">
          <div className="env-feature-image">
            <img src="/env1.png" alt="Environmental Impact Assessment" />
          </div>
          <div className="env-feature-text">
            <h3>Environmental Impact Assessment</h3>
            <p>
              Assessing potential environmental impacts of projects and providing actionable insights to minimize negative effects.
            </p>
          </div>
        </div>
      </section>

      {/* Feature Section 2: Pollution Control & CRZ */}
      <section className="env-feature-section reverse">
        <div className="section__container env-feature-container">
          <div className="env-feature-image">
            <img src="/env2.png" alt="Pollution Control and CRZ" />
          </div>
          <div className="env-feature-text">
            <h3>Pollution Control & CRZ Compliance</h3>
            <p>
              Helping organizations comply with Pollution Control Board approvals and Coastal Regulation Zone (CRZ) regulations.
            </p>
          </div>
        </div>
      </section>

      {/* Feature Section 3: Environmental Audits & Management Plans */}
      <section className="env-feature-section">
        <div className="section__container env-feature-container">
          <div className="env-feature-image">
          <img src="/env3.png" alt="Environmental Audits and Management Plans" />
          </div>
          <div className="env-feature-text">
            <h3>Environmental Audits & Management Plans</h3>
            <p>
              Conducting thorough audits and creating management plans to ensure sustainable and compliant operations.
            </p>
          </div>
        </div>
      </section>

      {/* Feature Section 4: Sustainability & Carbon Footprint */}
      <section className="env-feature-section reverse">
        <div className="section__container env-feature-container">
          <div className="env-feature-image">
            
            <img src="/env4.png" alt="Sustainability and Carbon Footprint" />
          </div>
          <div className="env-feature-text">
            <h3>Sustainability & Carbon Footprint Studies</h3>
            <p>
              Implementing sustainable practices, monitoring carbon emissions, and promoting biodiversity to create a greener future.
            </p>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'information-technology', title: 'Information Technology', icon: '/bgs/IT_bg.png' },
          { id: 'gis-services', title: 'GIS and Data Services', icon:'/bgs/GIS.png' },
          { id: 'health', title: 'Health', icon:'/bgs/health.png' },
          { id: 'agriculture', title: 'Agriculture', icon: '/bgs/agriculture.png' },
          { id: 'education-research', title: 'Education & Research', icon:'/bgs/edu.png' }
        ]}
      />
    </div>
  );
}

// Reusable Environment Feature Section Component
function EnvironmentFeatureSection({ title, text, imgSrc, imgAlt, reverse }) {
  return (
    <section className={`env-feature-section${reverse ? ' reverse' : ''}`}>
      <div className="section__container env-feature-container">
        <div className="env-feature-image">
          <img src={imgSrc} alt={imgAlt} />
        </div>
        <div className="env-feature-text">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </div>
    </section>
  );
}

export default EnvironmentPage;